import { Col, Row, Typography } from "antd"
import PropTypes from "prop-types"
import React from "react"
import { useHistory } from "react-router-dom"
import styled from "styled-components"

import AppButton from "../../../_shared/components/AppButton"
import AppInput from "../../../_shared/components/FormItems/AppInput"
import useForm from "../../../_shared/hooks/useForm"

// ----------------------------------------------------------------------------

function _LoginForm(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, onFinish, Error } = props
    const { Title } = Typography

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    const [formValues, setFormValue] = useForm({
        email: null,
        password: null,
    })

    const history = useHistory()

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function toSignup() {
        history.push("/signup")
    }

    function toPasswordReset() {
        history.push("/password-reset")
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault()
                onFinish(formValues)
            }}
            className={className}
        >
            <div className="form-item">
                <Title level={3}>Accedi</Title>
                {Error}
                <Row gutter={12}>
                    <Col span={24}>
                        <AppInput
                            label="E-mail"
                            value={formValues?.email}
                            required={true}
                            onChange={(value) => {
                                setFormValue("email", value)
                            }}
                        />
                    </Col>
                    <Col span={24}>
                        <AppInput
                            label="Password"
                            value={formValues?.password}
                            required={true}
                            hiddenText={true}
                            onChange={(value) => {
                                setFormValue("password", value)
                            }}
                        />
                        <small
                            className="forgot-password"
                            onClick={toPasswordReset}
                        >
                            Password dimenticata
                        </small>
                    </Col>
                </Row>
            </div>
            <div className="form-item">
                <AppButton className="primary" type="submit">
                    Accedi
                </AppButton>
            </div>
            <small>
                <span>Non hai un account? </span>
                <span className="section-link" onClick={toSignup}>
                    Registrati!
                </span>
            </small>
        </form>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_LoginForm.propTypes = {
    className: PropTypes.string.isRequired,
    onFinish: PropTypes.func,
    Error: PropTypes.any,
}

_LoginForm.defaultProps = {}

// ----------------------------------------------------------------------------

const LoginForm = styled(_LoginForm)`
    & {
        .forgot-password {
            display: block;
            align-self: flex-end;
            text-align: right;
            text-decoration: underline;
            cursor: pointer;
        }
    }
`
// ----------------------------------------------------------------------------

export default LoginForm
